<template>
  <div>
    <template v-for="item in items">
      <template v-if="item.type === 4">
        <span :key=item.xxx class="document-lists-accordion-item" :class="{ 'is-current': item.id === state.themeId }" @click="changeTheme.emitEvent(item.id)" :id="'toc_' + item.id" v-html="'・' + item.title" @touchstart="onTapStart($event.target)" @touchend="onTapEnd($event.target)"></span>
      </template>
      <template v-else>
        <div :key=item.xxx class="document-lists-accordion">
          <button class="document-lists-accordion-head" :class="{ 'is-open': item.isOpen }" @click="toggleItem(item)" v-html="item.title"></button>
          <div class="document-lists-accordion-body">
            <PCDocumentPartAccordion ref="accordionRef" :items="item.children" @changeTheme="changeTheme.emitEvent" />  
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { defineComponent, reactive, computed } from '@vue/composition-api'
import store from '@/store'

export default defineComponent({
  name: 'PCDocumentPartAccordion',
  props: {
    items: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  methods: {
    toggleItem(item) {
      if (item.children && item.type !== 4) {
        this.$set(item, 'isOpen', !item.isOpen) // 開閉状態を切り替える
      }
    },
    openAllItems() {
      this.items.forEach(item => {
        this.$set(item, 'isOpen', true) // 開閉状態を全て開く
        if (item.children) {
          this.openAllItemsRecursive(item.children)
        }
      })
    },
    closeAllItems() {
      this.items.forEach(item => {
        this.$set(item, 'isOpen', false) // 開閉状態を全て閉じる
        if (item.children) {
          this.closeAllItemsRecursive(item.children)
        }
      })
    },
    openAllItemsRecursive(items) {
      items.forEach(item => {
        this.$set(item, 'isOpen', true) // 開閉状態を全て開く
        if (item.children) {
          this.openAllItemsRecursive(item.children)
        }
      })
    },
    closeAllItemsRecursive(items) {
      items.forEach(item => {
        this.$set(item, 'isOpen', false) // 開閉状態を全て閉じる
        if (item.children) {
          this.closeAllItemsRecursive(item.children)
        }
      })
    },
    onTapStart(target) {
      target.style.backgroundColor = '#D4E7F4'
      // target.style.backgroundColor = 'red'
    },
    onTapEnd(target) {
      target.style.backgroundColor = ''
    }
  },
  setup (props, context) {
    const changeTheme = reactive({
      emitEvent: (theme) => {
        context.emit('changeTheme', theme)
      }
    })

    const state = reactive({
      // テーマID
      themeId: computed(() => {
        return store.state.precedent.themeId
      })
    })

    return {
      props,
      context,
      changeTheme,
      state
    }
  }
})
</script>
